import React from 'react';

const AlignTextLeftIcon = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      stroke="none"
      fillRule="evenodd"
      transform="translate(-12.000000, -12.000000)"
      d="M12,12 L28,12 L28,14 L12,14 L12,12 Z M12,16 L20,16 L20,17 L12,17 L12,16 Z M12,19 L28,19 L28,21 L12,21 L12,19 Z M12,23 L20,23 L20,24 L12,24 L12,23 Z M12,26 L28,26 L28,28 L12,28 L12,26 Z"
    />
  </svg>
);

export default AlignTextLeftIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/align-text-left-icon.js